var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-help.0116507c.png","uri@2x": __webpack_public_path__ + "icon-help.94db3759.png","uri@3x": __webpack_public_path__ + "icon-help.892f6d30.png",
    width: 20,
    height: 20
});